import '../scrutinizer/onView.css';
import React, { useState, useEffect } from "react";
import jwt from 'jwt-decode';
import { GET_ALL_STAKEHOLDERS, GET_STAKEHOLDER_BY_URN, GET_APPLICATION_COMMENTS, ALLOCATE_WORKFLOW, GET_USER_DETAILS} from '../../../common/URLs';
import back from '../../../images/backButton.png';
import ArrowBackIosNew from "@mui/icons-material/ArrowBackIosNew";
import { useNavigate, useLocation } from "react-router-dom";
import searchIcon from '../../../images/searchIcon.png';
import moment from 'moment';
import { confirmAlert } from 'react-confirm-alert';
import { ConfirmPopover } from '../../../preregcamps/confirmPopover/confirmPopover';
import { ErrorPopover } from '../../../common/ErrorPopover/errorPopover';
import { BASIC_DATE_FORMAT, LAND_AREA_UNIT, SPECIES_1, SPECIES_2, SPECIES_OTHER } from '../../../common/constants';
import { Container, Row, Col, Stack,Table } from 'react-bootstrap';
import resolveIcon from "../../../images/resolved.png";
import { loaderService } from '../../../common/custom-loader/loader-service';
import Accordion from 'react-bootstrap/Accordion';
import Card from 'react-bootstrap/Card';
import { stakeholderType } from '../../../common/spinLoader';

import ViewComments from '../scrutinizer/viewComments';
function StakeholderClarifications() {
  const navigate = useNavigate();
  const location = useLocation();
  

  const onEdit = (e) => {
    e.preventDefault();
    if (stakeholderType == "Transporter") {
      navigate("/dashboardHome/registrationDetailsTransporter")
    } else if (stakeholderType == "Grower" || stakeholderType == "Individual" || stakeholderType == "JFMC" || stakeholderType === "Other Agency") {
      navigate("/dashboardHome/registrationDetails");
    } else if (stakeholderType == "HIT") {
      navigate("/dashboardHome/registrationDetailsHit");
    } else if (stakeholderType == "LLE") {
      navigate("/dashboardHome/registrationDetailsLle")
    } else if (stakeholderType == "Interim Storage Operator") {
      navigate("/dashboardHome/registrationDetailsTempStorage")
    } else if (stakeholderType == "Forest") {
      navigate("/dashboardHome/registrationDetailsForest")
    } else if (stakeholderType === "Co-operative" || stakeholderType === "FPO" || stakeholderType === "SHG" || stakeholderType === "FPC") {
      navigate("/dashboardHome/registrationMemberDetails")
    }
  }
  
 
  return (
    <div>
            <Container fluid>
                <Row>
                    <Col xs={12} md={12}>
                    <div>
                        <form>
                            <Container fluid >
                                <Row>
                                    
                                     
                                        <div>&nbsp;</div>
                                        <div> <input className="submit_button_shortlist" type="submit" value="Edit" onClick={(e) => onEdit(e)} /></div>

                                        <Col xs={12} md={12}>
                                       
     

      <ViewComments></ViewComments>  
                                         </Col>
                                         </Row>
                                         </Container>
                                         </form>
                                         </div>


                    </Col>
          </Row></Container></div>
  );

}

export default StakeholderClarifications;
